export const PROGRAM_HUBS_RESET_STATE = 'PROGRAM_HUBS_RESET_STATE';
export const PROGRAM_HUBS_CURRENT_ITEM = 'PROGRAM_HUBS_CURRENT_ITEM';

export const PROGRAM_HUBS_REQUEST_LOADING = 'PROGRAM_HUBS_REQUEST_LOADING';
export const PROGRAM_HUBS_REQUEST_SUCCESS = 'PROGRAM_HUBS_REQUEST_SUCCESS';
export const PROGRAM_HUBS_REQUEST_FAILED = 'PROGRAM_HUBS_REQUEST_FAILED';

export const PROGRAM_HUBS_CURRENT_ACTION = 'PROGRAM_HUBS_CURRENT_ACTION';
export const PROGRAM_HUBS_RESET_ACTION = 'PROGRAM_HUBS_RESET_ACTION';